import { useState, useEffect } from "react";
import { SheetDataPoint, AppContext } from "../types";
import ElectionsDataContext from "../context/ElectionsDataContext";

type SheetDataResponse = {
  timestamp: string;
  data: SheetDataPoint[];
};

function AppContextProvider({ children }: { children: React.ReactNode }) {
  const [contextData, setContextData] = useState<AppContext>(null);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const dataUrl =
      window.usElections?.dataUrl || process.env.REACT_APP_DATA_URL;

    if (!dataUrl) return;

    try {
      const response = await fetch(dataUrl);
      const data = (await response.json()) as SheetDataResponse;

      if (!data.data) return;

      setContextData({
        sheetData: data.data.map((sheetDataPoint) => {
          const dateParts = sheetDataPoint.Date.replaceAll("-", "/")
            .split("/")
            .reverse();
          const formattedDate = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;

          const winnerParts = sheetDataPoint.winner.split(" ");
          winnerParts[0] = winnerParts[0].charAt(0) + ".";
          const formattedWinner = winnerParts.join(" ");

          return {
            ...sheetDataPoint,
            Date: formattedDate,
            winner: formattedWinner,
          };
        }),
      });
    } catch (error) {
      console.log(error);
    }
  }

  if (!contextData) return null;

  return (
    <ElectionsDataContext.Provider value={contextData}>
      {children}
    </ElectionsDataContext.Provider>
  );
}

export default AppContextProvider;
